<div class="create-household-ui">

  <se-fe-card>
    <se-fe-card-content>
      <header class="setup-bar-header">
        <se-po-setup-bar
          [seFeDataTitle]="setupService.title"
          [percentage]="setupService.percentComplete"
        ></se-po-setup-bar>
      </header>

      <div class="page-content">
        <router-outlet></router-outlet>
      </div>

      <footer class="page-footer">
        <p><a href="https://www.sportsengine.com/solutions" seFeLink>What's SportsEngine?</a></p>
        <p>Need Help? <a href="https://intercom.help/SportsEngine/en/" seFeLink>SportsEngine Help Center</a></p>
      </footer>
    </se-fe-card-content>
  </se-fe-card>

  <footer class="se-footer">
    <a seFeLink
      target="_blank"
      href="https://www.sportsengine.com/terms-of-use"
      id="footer-link-terms-of-use"
      (click)="analyticsService.seEvent('TermsOfServiceClick')">Terms of Use</a> |
    <a seFeLink
      target="_blank"
      href="https://www.versantprivacy.com/privacy?brandA=SportsEngine&intake=SportsEngine"
      id="footer-link-privacy-policy"
      (click)="analyticsService.seEvent('PrivacyPolicyClick')">Privacy Policy</a>
    <br>
    © 2020 - {{ footerYear }}
    <a seFeLink
      target="_blank"
      href="http://www.sportsengine.com"
      id="footer-link-sportsengine"
      (click)="analyticsService.seEvent('SportsEngineHomepageClick')">SportsEngine, LLC.</a>
    All Rights Reserved.
  </footer>
</div>
